module.exports = __webpack_public_path__ + "static/img/lab-report.9370a1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/lab-report.svg
// module id = /so/
// module chunks = 24